import React from 'react';
import PropTypes from 'prop-types';
import {
  ExtendedBox,
  ExtendedFlex,
  Link,
  isDrupal,
} from '../../coreui';

const HeaderUserMenuLoggedOut = ({
  handleMouseEnter,
  handleMouseLeave,
  hoveredItem,
  isLimitedNav,
  isRegFlow,
}) => {
  const inDrupal = isDrupal();
  return (
    !isRegFlow ?
      <>
        <ExtendedFlex
          flexDirection="column"
          display={isLimitedNav ? 'none' : ['none', 'none', 'none', 'flex']}
          position="relative"
          justify="center"
          id="sign_in"
          pr={5}
          pl={10}
          ml={10}
          mr={15}
          height={[70, 70, 80, 90]}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Link
            color="gray.8"
            display="block"
            type="L5"
            {...{
              [inDrupal ? 'href' : 'to']: '/user/login',
            }}
            whiteSpace="nowrap"
          >
            Sign In
          </Link>
          <ExtendedBox
            position="absolute"
            height={1}
            bg="black"
            w={1}
            bottom={25}
            left={0}
            opacity={
              hoveredItem === 'sign_in' ?
                '1' :
                '0'
            }
            transition="opacity 0.5s linear"
          />
        </ExtendedFlex>
        <Link
          type="L1mini"
          {...{
            [inDrupal ? 'href' : 'to']: '/user/register',
          }}
        >
          Join
        </Link>
      </> :
      <>
        <Link
          type="L1mini"
          to="/user/login"
          display={['none', 'none', 'none', 'block']}
        >
          Sign In
        </Link>
      </>
  );
};

HeaderUserMenuLoggedOut.propTypes = {
  handleMouseEnter: PropTypes.func,
  handleMouseLeave: PropTypes.func,
  hoveredItem: PropTypes.string,
  isLimitedNav: PropTypes.bool,
  isRegFlow: PropTypes.bool,
};

export default HeaderUserMenuLoggedOut;
